import { Link, useParams } from 'react-router-dom'
import { Breadcrumbs } from '../components/Breadcrumbs'
import { ContentCard } from '../components/ContentCard'
import { getContentsByDeity } from '../data/content'
import { DEITIES } from '../data/deities'
import { useSeo } from '../hooks/useSeo'
import type { DeityId } from '../data/types'

export function DeitiesPage() {
  useSeo({
    title: 'தெய்வங்கள்',
    description: 'தெய்வம் வாரியாக பக்திப் பாடல்கள் மற்றும் ஸ்துதிகள்.',
    path: '/deities',
  })

  return (
    <div className="page-hero">
      <div className="container section">
        <Breadcrumbs items={[{ label: 'முகப்பு', to: '/' }, { label: 'தெய்வங்கள்' }]} />
        <div className="section-header">
          <h1>தெய்வங்கள்</h1>
          <p>உங்கள் இஷ்ட தெய்வத்தின் பாடல்களையும் ஸ்துதிகளையும் தேர்ந்தெடுங்கள்.</p>
        </div>
        <div className="card-grid card-grid--3">
          {DEITIES.map((d) => (
            <Link key={d.id} to={`/deities/${d.id}`} className="content-card">
              <span className="content-card__meta">{d.nameEn}</span>
              <h3>{d.nameTa}</h3>
              <p>{d.descriptionTa}</p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  )
}

export function DeityDetailPage() {
  const { deityId = '' } = useParams()
  const deity = DEITIES.find((d) => d.id === deityId)
  const items = getContentsByDeity(deityId as DeityId)

  useSeo({
    title: deity ? deity.nameTa : 'தெய்வம்',
    description: deity?.descriptionTa,
    path: `/deities/${deityId}`,
  })

  if (!deity) {
    return (
      <div className="container section">
        <div className="empty-state">
          <h1>தெய்வம் கிடைக்கவில்லை</h1>
          <Link className="btn btn--primary" to="/deities">
            பட்டியலுக்குச் செல்லவும்
          </Link>
        </div>
      </div>
    )
  }

  return (
    <div className="page-hero">
      <div className="container section">
        <Breadcrumbs
          items={[
            { label: 'முகப்பு', to: '/' },
            { label: 'தெய்வங்கள்', to: '/deities' },
            { label: deity.nameTa },
          ]}
        />
        <div className="section-header">
          <h1>{deity.nameTa}</h1>
          <p>
            {deity.nameEn} — {deity.descriptionTa}
          </p>
        </div>
        {items.length === 0 ? (
          <div className="empty-state">இந்தத் தெய்வத்திற்கான உள்ளடக்கம் விரைவில் சேர்க்கப்படும்.</div>
        ) : (
          <div className="card-grid card-grid--3">
            {items.map((item) => (
              <ContentCard key={item.id} item={item} />
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
